"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openRealNameVerifyPopup = void 0;
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var verify_frame_1 = require("./util/verify-frame");
var withReport_1 = require("../hoc/withReport");
/* 打开账号实名认证弹框
 * @param params
 * @returns
 */
var $openRealNameVerifyPopup = function (params) {
    var id = 'meeting-components-account-real-name-verify-popup';
    var bodyId = "".concat(id, "_body");
    var page = '/v2/account-corp-real-name-verify';
    // 前往验证流程
    var continueVerify = function () {
        var _a;
        if (!document.querySelector("#".concat(id))) {
            // 遮罩层
            var maskEl = document.createElement('div');
            maskEl.id = id;
            maskEl.style.position = 'fixed';
            maskEl.style.width = '100%';
            maskEl.style.height = '100%';
            maskEl.style.top = '0px';
            maskEl.style.left = '0px';
            maskEl.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            maskEl.style.zIndex = '999999999';
            document.body.appendChild(maskEl);
            // iframe位置
            var el = document.createElement('div');
            el.id = bodyId;
            el.style.position = 'absolute';
            el.style.borderRadius = '4px';
            el.style.overflow = 'hidden';
            el.style.display = 'flex';
            el.style.justifyContent = 'center';
            el.style.alignItems = 'center';
            el.style.backgroundColor = '#ffffff';
            el.innerHTML = '<img id="iframe_loading_icon" src="https://cdn.meeting.tencent.com/assets/global/img/meeting-loading.20221121.apng" style="position: absolute;width:120px;height:111px">';
            if ((0, web_base_1.isMobile)()) {
                el.style.top = '0%';
                el.style.left = '0%';
                el.style.borderRadius = '0';
            }
            else {
                el.style.top = '50%';
                el.style.left = '50%';
                el.style.transform = 'translateX(-50%) translateY(-50%)';
                el.style.borderRadius = '4px';
                el.style.width = '520px';
                var verifyList = (params === null || params === void 0 ? void 0 : params.corp_real_name_means_list) || [];
                if (verifyList.length === 1) {
                    el.style.height = '317px';
                }
                else {
                    el.style.height = '407px';
                }
            }
            (_a = document.querySelector("#".concat(id))) === null || _a === void 0 ? void 0 : _a.appendChild(el);
        }
        (0, verify_frame_1.openVerifyFrame)(tslib_1.__assign(tslib_1.__assign({ page: page, id: bodyId, containerId: id }, params), { onClose: handleClose, onSuccess: handleSuccess, onFailed: handleFailed, onSkip: handleSkip }));
    };
    var onDestroy = function () {
        var _a;
        (_a = document.querySelector("#".concat(id))) === null || _a === void 0 ? void 0 : _a.remove();
    };
    var onSuccess = params.onSuccess, onClose = params.onClose, onFailed = params.onFailed, onSkip = params.onSkip, onBack = params.onBack;
    var closeModal = function () {
        onDestroy();
    };
    var handleClose = function (v) {
        closeModal();
        onClose === null || onClose === void 0 ? void 0 : onClose(v);
        onBack === null || onBack === void 0 ? void 0 : onBack();
    };
    var handleSuccess = function (v) {
        closeModal();
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(v);
    };
    var handleSkip = function (v) {
        closeModal();
        onSkip === null || onSkip === void 0 ? void 0 : onSkip(v);
    };
    var handleFailed = function (v) {
        onFailed === null || onFailed === void 0 ? void 0 : onFailed(v);
    };
    continueVerify();
};
exports.openRealNameVerifyPopup = (0, withReport_1.withFunctionReport)($openRealNameVerifyPopup, 'RealNameVerify');
//# sourceMappingURL=verify-container.js.map